import React from 'react'
import Search from '../../molecules/search'

const None = () => {
  return (
    <Search/>
  )
}

export default None